const navs = [
  { href: "#trending", label: "今日热榜" },
  { href: "#feed", label: "瓜田上新" },
  { href: "#feature", label: "深度大瓜" },
  { href: "#reviews", label: "网友辣评" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

const topics = ["娱乐八卦", "社会热点", "影视综艺", "生活趣谈", "热瓜合集", "深度长稿"];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="wrap py-12">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-music-2-line text-lg"></i>
              </span>
              <span className="font-display text-lg font-black text-background-50">
                吃瓜<span className="text-accent-400">五一</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              每天上新娱乐八卦、社会热点与热瓜合集的原创内容门户。热点再热，我们想让你吃得更明白、更安心。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold uppercase tracking-widest text-background-50">快速导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-3">
              {navs.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="whitespace-nowrap text-sm text-background-300 transition hover:text-accent-300">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold uppercase tracking-widest text-background-50">内容栏目</h3>
            <ul className="mt-4 flex flex-wrap gap-2">
              {topics.map((t) => (
                <li key={t}>
                  <a
                    href="#feed"
                    className="inline-flex whitespace-nowrap rounded-full border border-background-700 px-3.5 py-1.5 text-xs text-background-200 transition hover:border-accent-400 hover:text-accent-300"
                  >
                    {t}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-800 pt-6 sm:flex-row">
          <p className="text-xs text-background-400">© {new Date().getFullYear()} 吃瓜五一 · 尊重原创，转载注明出处</p>
          <div className="flex items-center gap-4">
            <a href="#top" aria-label="返回顶部" className="text-background-400 transition hover:text-accent-300">
              <i className="ri-arrow-up-line"></i>
            </a>
            <a href="#subscribe" className="whitespace-nowrap text-xs text-background-400 transition hover:text-accent-300">
              订阅早报
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}